import React, { useEffect, useState, useRef } from 'react';
import './Portfolio.css';

import { PortfolioItem, PortfolioTabs } from '../../components';
import { portfolio } from '../../constants';

import Isotope from 'isotope-layout';
import Lightbox from "react-18-image-lightbox";
import "react-18-image-lightbox/style.css";



const Portfolio = () => {

  // State
  const [category, setCategory] = useState('all');
  const iso = useRef(null);
  const gridRef = useRef(null);

  // Lightbox State
  const [index, setIndex] = useState(-1);
  const currentImage = portfolio[index];
  const nextIndex = (index + 1) % portfolio.length;
  const nextImage = portfolio[nextIndex] || currentImage;
  const prevIndex = (index + portfolio.length - 1) % portfolio.length;
  const prevImage = portfolio[prevIndex] || currentImage;

  const openLightbox = (index) => setIndex(index);
  const closeLightbox = () => setIndex(-1);
  const handleMovePrev = () => setIndex(prevIndex);
  const handleMoveNext = () => setIndex(nextIndex);

  // Function to format category names as Isotope classes
  const formatCategory = (name) => name.toLowerCase().replace(/\s+/g, '-');

  // Get unique categories from portfolio
  const categories = ['all', ...new Set(portfolio.map(item => formatCategory(item.details.category)))];

  // Initialize Isotope
  useEffect(() => {
    iso.current = new Isotope(gridRef.current, {
      itemSelector: '.portfolio-item',
      layoutMode: 'fitRows',
    });

    return () => {
      iso.current.destroy();
    };
  }, []);

  // Apply filter when category changes
  useEffect(() => {
    if (iso.current) {
      iso.current.arrange({
        filter: category === 'all' ? '*' : `.${category}`, // Filters by class name
      });
    }
  }, [category]);

  return (
    <div className='portfolio'>

      {/* Portfolio Tabs */}
      <ul className="tab-buttons">
        {categories.map((item) => (
          <PortfolioTabs
            key={item}
            id={item}
            title={item.replace(/-/g, ' ')} // Show original category name
            setSelected={() => setCategory(item)}
            active={category === item}
          />
        ))}
      </ul>

      {/* Portfolio Grid */}
      <div className="box-container" ref={gridRef}>
        {portfolio.map((item, index) => {
          const className = formatCategory(item.details.category);
          return (
            <PortfolioItem
              key={item.id}
              id={index}
              image={item.image}
              title={item.title}
              category={item.details.category}
              portfolio={item}
              className={className} // Add class for Isotope filtering
              popup={openLightbox}
            />
          );
        })}
      </div>

      {/* Lightbox */}
      {index !== -1 && (
        <Lightbox
          mainSrc={currentImage.image}
          imageTitle={currentImage.title}
          mainSrcThumbnail={currentImage.image}
          nextSrc={nextImage.image}
          nextSrcThumbnail={nextImage.image}
          prevSrc={prevImage.image}
          prevSrcThumbnail={prevImage.image}
          onCloseRequest={closeLightbox}
          onMovePrevRequest={handleMovePrev}
          onMoveNextRequest={handleMoveNext}
        />
      )}
    </div>
  );
};

export default Portfolio;